/* usercentrics.js (V3-ready) */

const SERVICE_IDS = {
  "Sovendus": "Di_NMaFOX",
  "Trusted Shops": "HJrGqEs_i-Q",
  "YouTube Video": "BJz7qNsdj-7",
  "Google Maps": "S1pcEj_jZX",
  "Klaviyo": "m5uB6gnoW",
  "User Centrics": "H1Vl5NidjWX",
  "Facebook Pixel": "ko1w5PpFl",
  "Google Ads": "S1_9Vsuj-Q",
  "Google Analytics 4": "87JYasXPF",
  "Pinterest": "9Q2qrmB3",
  "Microsoft Advertising Remarketing": "dsS7z9Hv4",
  "Pinterest Tags": "a_Dw7zFT7",
  "TikTok Advertising": "6-qobRfu",
  "Microsoft Advertising": "BkeKqEjuoZQ",
  "Shopify Tracking": "BNMuzQjTe",
  "Varify.io": "DgK0ku83emM6Qz",
  "Shopify Marketing": "zixK7I8y1mhf1D",
  "Shopify Preferences": "T4PQQdTkrEofhd",
  "Shopify Analytics": "ZQOx-TM97Y3rLe",
  "Facebook Custom Audiences": "PVHsaPKmk"
};

// Helper: check if a given service is currently accepted
function isServiceAccepted(serviceName) {
  // consentDetail is updated in the uc_event listener below.
  if (window.consentDetail && window.consentDetail[serviceName] === true) {
    return true;
  }
  return false;
}

// Helper: get the V3 ID for a given service name
function getServiceId(serviceName) {
  return SERVICE_IDS[serviceName] || null;
}

////////////////////////////////////////////////////////////////
// 2) Run on DOMContentLoaded: link “Privacy” click, etc.     //
////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', () => {
  const privacyLink = document.querySelector('.footer__privacy-link');
  
  // Open second-layer panel when user clicks the privacy link
  if (privacyLink) {
    privacyLink.addEventListener('click', (event) => {
      event.preventDefault();
      if (window.__ucCmp && window.__ucCmp.showSecondLayer) {
        window.__ucCmp.showSecondLayer();
      }
    });
  }
});

// 3) Listen for the V3 “uc_event” and store the consent object
window.addEventListener('uc_event', async function(e) {
  // e.detail should contain your current consents (serviceName -> boolean).
  if (!e.detail) return;
  
  // Keep a reference to all consent data
  window.consentDetail = e.detail;
  
  // If this was an explicit user choice event, sync with Shopify
  if (e.detail.event === 'consent_status' && e.detail.type.toLowerCase() === 'explicit') {
    const functionalConsent = !!e.detail?.ucCategory?.functional;
    const marketingConsent = !!e.detail?.ucCategory?.marketing;

    // Update Shopify tracking consent
    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        () => {
          // Set the correct categories:
          window.Shopify.customerPrivacy.setTrackingConsent({
            "analytics": functionalConsent,
            "marketing": marketingConsent,
            "preferences": functionalConsent,
            "sale_of_data": functionalConsent && marketingConsent,
          }, () => {});
        }
      );
    }

    // If we already had an initial consent and something was just revoked, reload:
    if (window.initialConsentSet) {
      const anyRevoked = Object.keys(e.detail).some((serviceName) => e.detail[serviceName] === false);
      if (anyRevoked) {
        window.location.reload();
      }
    } else {
      window.initialConsentSet = true; // first explicit setting
    }
  }

  // If scripts or iframes have data-usercentrics, load them if now accepted
  document.querySelectorAll('[data-usercentrics]').forEach((el) => {
    const serviceName = el.getAttribute('data-usercentrics');
    if (isServiceAccepted(serviceName)) {
      // Turn them "live"
      if (el.tagName.toLowerCase() === 'iframe') {
        el.setAttribute('src', el.getAttribute('data-src'));
      } else {
        el.type = "text/javascript";
      }
      el.removeAttribute('data-usercentrics');
    }
  });
});

////////////////////////////////////////////////////////////////////////////////////
// 4) Monkey-patch document.createElement to intercept dynamic <script> or <iframe> //
////////////////////////////////////////////////////////////////////////////////////
const createElementBackup = document.createElement;
const TYPE_ATTRIBUTE = 'text/plain';

const originalDescriptors = {
  href: Object.getOwnPropertyDescriptor(HTMLLinkElement.prototype, 'href'),
  src: Object.getOwnPropertyDescriptor(HTMLScriptElement.prototype, 'src'),
};

// Identify each script’s “service name” from its source
function getServiceNameFromSrc(src) {
  if (!src) return null;

  switch (true) {
    case /storelocator/.test(src):
    case /sca\./.test(src):
      return "Google Maps";
    case /trustedshops_shopify/.test(src):
      return "Trusted Shops";
    case /sovendus/.test(src):
      return "Sovendus";
    case /personalizer\.io/.test(src):
      return "LimeSpot";
    case /youtube/.test(src):
      return "YouTube Video";
    // Add more as needed
    default:
      return null;
  }
}

document.createElement = function(...args) {
  const tagName = args[0].toLowerCase();

  // Only intercept script, link, or iframe
  if (tagName !== 'script' && tagName !== 'link' && tagName !== 'iframe') {
    return createElementBackup.bind(document)(...args);
  }

  const element = createElementBackup.bind(document)(...args);

  try {
    Object.defineProperties(element, {
      href: {
        get() {
          return originalDescriptors.href?.get?.call(this);
        },
        set(value) {
          // Let through fonts from Google
          if (value.includes && (value.includes('fonts.google') || value.includes('gstatic'))) {
            return;
          }
          originalDescriptors.href?.set?.call(this, value);
        }
      },
      src: {
        get() {
          return originalDescriptors.src?.get?.call(this);
        },
        set(value) {
          element.setAttribute("src", value);
        }
      }
    });

    element.setAttribute = function(name, value) {
      if (name === 'src') {
        const serviceName = getServiceNameFromSrc(value);
        if (serviceName) {
          // If not accepted yet, store the real src in data-src
          // and set type to plain so it won't execute
          if (!isServiceAccepted(serviceName)) {
            if (tagName === 'iframe') {
              element.setAttribute('data-src', value);
            } else {
              element.type = TYPE_ATTRIBUTE;
            }
            element.setAttribute('data-usercentrics', serviceName);
          }
        }
      }

      if (name === 'href') {
        element[name] = value; // triggers the setter above
      } else {
        (tagName === 'script' ? HTMLScriptElement : HTMLLinkElement).prototype.setAttribute.call(element, name, value);
      }
    };
  } catch (error) {
    console.error(error);
  }

  return element;
};

/////////////////////////////////////////////////////////////////
// 5) On DOMContentLoaded again, handle existing <script> tags //
/////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function() {
  // For existing <script src="..."> or <iframe src="...">:
  const els = document.querySelectorAll('script[src], iframe');
  els.forEach((el) => {
    const srcValue = el.getAttribute('src');
    const serviceName = getServiceNameFromSrc(srcValue);
    if (serviceName && !isServiceAccepted(serviceName)) {
      el.setAttribute('data-src', srcValue);
      el.removeAttribute('src');
      el.setAttribute('data-usercentrics', serviceName);

      // If it’s YouTube, attach an overlay
      if (serviceName === "YouTube Video") {
        new ConsentOverlay(el, serviceName);
      }
    }
  });

  // Add overlay for Google Maps element or any custom container
  const mapContainer = document.querySelector("#scasl-app-container");
  if (mapContainer && !isServiceAccepted("Google Maps")) {
    new ConsentOverlay(mapContainer, "Google Maps");
  }

  // Example: attach overlay on all Klaviyo forms
  document.querySelectorAll('[class^="klaviyo-form-"]').forEach((el) => {
    if (!isServiceAccepted("Klaviyo")) {
      new ConsentOverlay(el, "Klaviyo");
    }
  });
});

/////////////////////////////////////////////////////////////////////
// 6) ConsentOverlay Class: shows “Accept” or “More Info” overlay. //
/////////////////////////////////////////////////////////////////////
class ConsentOverlay {
  constructor(element, serviceName) {
    if (!element || !serviceName) return;
    this.element = element;
    this.serviceName = serviceName;

    // If service is now accepted, do nothing
    if (isServiceAccepted(this.serviceName)) {
      return;
    }

    // Otherwise, create overlay only if user has made a first selection
    if (window.initialConsentSet) {
      this.createOverlay();
    }

    // Listen for future changes
    window.addEventListener('uc_event', (e) => {
      if (!e.detail) return;
      const accepted = !!e.detail[this.serviceName];
      if (accepted) {
        this.removeOverlay();
      } else if (!this.overlay) {
        this.createOverlay();
      }
    });
  }

  createOverlay() {
    this.overlay = document.createElement('div');
    this.overlay.className = 'modal consent-modal';
    this.overlay.setAttribute('open', true);

    // Insert your own strings or references:
    this.overlay.innerHTML = `
      <div class="modal__overlay"></div>
      <div class="modal__content">
        <strong>
          ${window.themeVariables.strings.consentModalTitle.replace("{{service}}", this.serviceName)}
        </strong>
        <p>${window.themeVariables.strings.consentModalDescription}</p>
        <div class="consent-buttons">
          <button class="button button--ternary moreInfoBtn">
            ${window.themeVariables.strings.consentModalInfo}
          </button>
          <button class="button button--primary acceptBtn">
            ${window.themeVariables.strings.consentModalAccept}
          </button>
        </div>
      </div>
    `;

    // Event listeners
    this.overlay.querySelector('.moreInfoBtn')?.addEventListener('click', () => this.onMoreInfo());
    this.overlay.querySelector('.acceptBtn')?.addEventListener('click', () => this.onAccept());

    // Insert overlay
    let insertBefore = this.element;
    let parent = this.element.parentNode;
    // Adjust if the parent has % padding for responsive iframes
    if (window.getComputedStyle(this.element).position === 'absolute' && parent.style.paddingBottom.includes('%')) {
      while (parent && parent.style && parent.style.paddingBottom.includes('%')) {
        insertBefore = parent;
        parent = parent.parentNode;
      }
    }
    parent.insertBefore(this.overlay, insertBefore);
  }

  onMoreInfo() {
    // If your V3 build still has .showSecondLayer(), call it here:
    const serviceId = getServiceId(this.serviceName);
    if (window.__ucCmp && window.__ucCmp.showSecondLayer) {
      // You can pass the service ID if supported:
      window.__ucCmp.showSecondLayer(serviceId);
    }
  }

  async onAccept() {
    // Accept a single service
    const serviceId = getServiceId(this.serviceName);
    if (serviceId && window.__ucCmp) {
      // Mark it as accepted, then explicitly save
      await window.__ucCmp.updateServicesConsents([{ id: serviceId, consent: true }]);
      await window.__ucCmp.saveConsents('EXPLICIT');
      this.removeOverlay();
    }
  }

  removeOverlay() {
    if (this.overlay) {
      this.overlay.parentNode?.removeChild(this.overlay);
    }
  }
}